import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import StatusLabel from '../../../../../commonComponents/StatusLabel';
import { compose } from '../../../../../services/utilityFunctions';

const PdfInfoSection = ({
  t,
  sectionTitle,
  title,
  maxDays,
  description,
  status,
  customContent,
}) => (
  <div className="m-portlet m-portlet-rounded">
    <div id="infoContainer" className="m-portlet__body">
      <span className="title">{sectionTitle}</span>
      {title && <span className="pdf-name">{title}</span>}
      {maxDays && <span className="max-days">{t('number.days', maxDays)}</span>}
      {status && <StatusLabel status={status} />}
      {description && <span className="description">{description}</span>}
      {customContent}
    </div>
  </div>
);

PdfInfoSection.propTypes = {
  t: PropTypes.func.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  maxDays: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  customContent: PropTypes.node,
};

PdfInfoSection.defaultProps = {
  customContent: null,
};

export default compose(translate)(PdfInfoSection);
